// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/BezierSans.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/BezierSans.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/BezierSans.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/BezierSansBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Bezier Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
         url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: normal;
    font-style: normal;

    font-family: 'Bezier Sans Bold';
    src:
         url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: normal;
    font-style: normal;

  }
  body {
    font-family: 'Bezier Sans', sans-serif;
  }

.services {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100vh; /* Фиксированная высота для десктопной версии */
    box-sizing: border-box;/* Учитываем паддинги в расчете высоты */
}

.migration-content {
    display: flex;
    align-items: center;
    width: 80%;
    max-width: 1200px;
    margin: 0 auto;
}

.migration-image-container {
    flex: 1 1;
    text-align: center;
}


.migration-image img {
    width: 100%; /* Adjust this value as needed */
    height: auto; /* Maintain aspect ratio */
    padding-right: 0;
}

.migration-text-container {
    flex: 1 1;
    padding-left: 30px;
}

.main-text
{
    font-family: 'Bezier Sans Bold';
}



.migration-text {
    flex: 1 1;
    padding: 20px;
}

.migration-image {
    flex: 1 1;
    display: flex;
    justify-content: center;
}



.main-text {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 20px;
}

.additional-info p {
    font-size: 18px;
    line-height: 1.6;
}
@media (max-width: 768px) {
    .migration-content {
        flex-direction: column;
        align-items: center;
        text-align: center;
        width: 100%; /* Контент будет занимать всю ширину */
    }

    .migration-text {
        padding: 10px;
    }

    .migration-image {
        margin-top: 20px; /* Add some space between text and image */
    }
    .migration-image img {
        max-width: 80%; /* Reduce the image size to 80% of its container width */
    }

    .services {
        height: auto; /* Убираем фиксированную высоту для мобильной версии */
        flex-direction: column;
        padding: 20px; /* Добавляем отступы для мобильных устройств */
    }


    .migration-text-container {
        padding-left: 0; /* Убираем левый отступ */
        padding-bottom: 20px; /* Добавляем нижний отступ для пространства между текстом и изображением */
    }

    .migration-image-container {
        margin-top: 20px; /* Добавляем отступ сверху */
    }


}`, "",{"version":3,"sources":["webpack://./src/styles/Migration.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B;;mEAEgE;IAChE,mBAAmB;IACnB,kBAAkB;;IAElB,+BAA+B;IAC/B;mEACoE;IACpE,mBAAmB;IACnB,kBAAkB;;EAEpB;EACA;IACE,sCAAsC;EACxC;;AAEF;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa,EAAE,+CAA+C;IAC9D,sBAAsB,CAAC,wCAAwC;AACnE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;;AAGA;IACI,WAAW,EAAE,gCAAgC;IAC7C,YAAY,EAAE,0BAA0B;IACxC,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;;IAEI,+BAA+B;AACnC;;;;AAIA;IACI,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,uBAAuB;AAC3B;;;;AAIA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,WAAW,EAAE,sCAAsC;IACvD;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB,EAAE,0CAA0C;IAChE;IACA;QACI,cAAc,EAAE,wDAAwD;IAC5E;;IAEA;QACI,YAAY,EAAE,sDAAsD;QACpE,sBAAsB;QACtB,aAAa,EAAE,8CAA8C;IACjE;;;IAGA;QACI,eAAe,EAAE,yBAAyB;QAC1C,oBAAoB,EAAE,0EAA0E;IACpG;;IAEA;QACI,gBAAgB,EAAE,4BAA4B;IAClD;;;AAGJ","sourcesContent":["@font-face {\r\n    font-family: 'Bezier Sans';\r\n    src: url('../../public/fonts/BezierSans.woff2') format('woff2'),\r\n         url('../../public/fonts/BezierSans.woff') format('woff'),\r\n         url('../../public/fonts/BezierSans.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n\r\n    font-family: 'Bezier Sans Bold';\r\n    src:\r\n         url('../../public/fonts/BezierSansBold.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n\r\n  }\r\n  body {\r\n    font-family: 'Bezier Sans', sans-serif;\r\n  }\r\n\r\n.services {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    height: 100vh; /* Фиксированная высота для десктопной версии */\r\n    box-sizing: border-box;/* Учитываем паддинги в расчете высоты */\r\n}\r\n\r\n.migration-content {\r\n    display: flex;\r\n    align-items: center;\r\n    width: 80%;\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.migration-image-container {\r\n    flex: 1;\r\n    text-align: center;\r\n}\r\n\r\n\r\n.migration-image img {\r\n    width: 100%; /* Adjust this value as needed */\r\n    height: auto; /* Maintain aspect ratio */\r\n    padding-right: 0;\r\n}\r\n\r\n.migration-text-container {\r\n    flex: 1;\r\n    padding-left: 30px;\r\n}\r\n\r\n.main-text\r\n{\r\n    font-family: 'Bezier Sans Bold';\r\n}\r\n\r\n\r\n\r\n.migration-text {\r\n    flex: 1;\r\n    padding: 20px;\r\n}\r\n\r\n.migration-image {\r\n    flex: 1;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n\r\n\r\n.main-text {\r\n    font-size: 32px;\r\n    font-weight: bold;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.additional-info p {\r\n    font-size: 18px;\r\n    line-height: 1.6;\r\n}\r\n@media (max-width: 768px) {\r\n    .migration-content {\r\n        flex-direction: column;\r\n        align-items: center;\r\n        text-align: center;\r\n        width: 100%; /* Контент будет занимать всю ширину */\r\n    }\r\n\r\n    .migration-text {\r\n        padding: 10px;\r\n    }\r\n\r\n    .migration-image {\r\n        margin-top: 20px; /* Add some space between text and image */\r\n    }\r\n    .migration-image img {\r\n        max-width: 80%; /* Reduce the image size to 80% of its container width */\r\n    }\r\n\r\n    .services {\r\n        height: auto; /* Убираем фиксированную высоту для мобильной версии */\r\n        flex-direction: column;\r\n        padding: 20px; /* Добавляем отступы для мобильных устройств */\r\n    }\r\n\r\n\r\n    .migration-text-container {\r\n        padding-left: 0; /* Убираем левый отступ */\r\n        padding-bottom: 20px; /* Добавляем нижний отступ для пространства между текстом и изображением */\r\n    }\r\n\r\n    .migration-image-container {\r\n        margin-top: 20px; /* Добавляем отступ сверху */\r\n    }\r\n\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
